<template>
    <Modal @close="handleClose" :is-open="isOpen">
        <component :is="component" :is-open="isOpen" v-bind="props"/>
    </Modal>
</template>

<script>
    import ModalBus from '../eventBus'
    import Modal from "./Modals/Modal";

    export default {
        components: {Modal},
        data() {
            return {
                isOpen: false,
                component: null,
                props: null
            }
        },
        methods: {
            handleClose: function () {
                this.isOpen = false;
                setTimeout(() => ModalBus.$emit('closed'), 600);
            }
        },
        created() {
            ModalBus.$on('open', ({component, props = null}) => {
                this.component = component;
                this.props = props;
                this.isOpen = true;
            });

            ModalBus.$on('close', () => this.handleClose());
        }
    }
</script>
